import { request as addNewBanner } from './reducers/add-new-banner';
import { request as uploadBannerImage } from './reducers/upload-banner-image';
import { request as getAllBanners } from './reducers/get-all-banners';
import { request as updateBanner } from './reducers/update-banner';
import { request as deleteBanner } from './reducers/delete-banner';
import { request as updateBannerSlideTime } from './reducers/update-banner-slide';
import { request as getBannerConfig } from './reducers/get-banner-config';
import { request as changePromotionOrder } from './reducers/change-promotion-order';

// eslint-disable-next-line import/no-default-export
export default {
    ADD_NEW_BANNER_REQUEST: addNewBanner,
    UPLOAD_BANNER_IMAGE_REQUEST: uploadBannerImage,
    GET_ALL_BANNERS_REQUEST: getAllBanners,
    UPDATE_BANNER_REQUEST: updateBanner,
    DELETE_BANNER_REQUEST: deleteBanner,
    UPDATE_BANNER_SLIDE_TIME_REQUEST: updateBannerSlideTime,
    GET_BANNER_CONFIG_REQUEST: getBannerConfig,
    CHANGE_PROMOTION_ORDER_REQUEST: changePromotionOrder,
};
